import SignupPage from '@/modules/signup-page/SignupPage'

export default function Home() {
    return <SignupPage />
}
